import React from 'react';
const IconArrowZoom = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M5.3 6.7L3 9V3H9L6.7 5.3L9.59 8.17L8.17 9.59L5.3 6.7ZM17.3 5.3L15 3H21V9L18.7 6.7L15.83 9.59L14.41 8.17L17.3 5.3ZM9 21L6.7 18.7L9.59 15.83L8.17 14.41L5.3 17.3L3 15V21H9ZM18.7 17.3L21 15V21H15L17.3 18.7L14.41 15.83L15.83 14.41L18.7 17.3Z" fill="#666666"/>
</svg>
);
};
export default IconArrowZoom;